"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/no-multi-comp */
const react_1 = __importStar(require("react"));
const moment_1 = __importDefault(require("moment"));
//
// assets
//
const noSearch_webp_1 = __importDefault(require("assets/images/dashboard/noSearch.webp"));
const shippingCopy_1 = require("copy/shippingCopy");
const queryDefinitions_1 = require("queryDefinitions");
const tooltip_svg_1 = __importDefault(require("assets/images/tooltip.svg"));
//
// components
//
const DataTable_1 = __importDefault(require("components/Dashboard/Tables/DataTable"));
const ShippingModal_1 = __importDefault(require("components/Dashboard/Modals/ShippingModal"));
const DatePickerInput_1 = __importDefault(require("components/Dashboard/DatePickerInput"));
const PieChart_1 = __importDefault(require("components/Dashboard/Charts/PieChart"));
const FilterDropdown_1 = __importDefault(require("components/Dashboard/FilterDropdown"));
const LoadingSpinner_1 = __importDefault(require("components/general/LoadingSpinner"));
//
// hooks
//
const useInfiniteScroll_1 = require("hooks/useInfiniteScroll");
const client_1 = require("@apollo/client");
const queryParams_1 = __importDefault(require("components/general/queryParams/queryParams"));
const useAccountChange_1 = __importDefault(require("components/useAccountChange"));
//
// styles
//
const StyledHeader_1 = require("components/Dashboard/StyledHeader");
const StyledHeaderContainer_1 = require("components/Dashboard/StyledHeaderContainer");
const StyledMainContainer_1 = require("components/Dashboard/StyledMainContainer");
const StyledSubHeader_1 = require("components/Dashboard/StyledSubHeader");
const StyledInputsContainer_1 = require("components/Dashboard/StyledInputsContainer");
const StyledFilterContainer_1 = require("components/Dashboard/StyledFilterContainer");
const StyledIcon_1 = require("components/Dashboard/StyledIcon");
const StyledSectionContainer_1 = require("components/Dashboard/StyledSectionContainer");
const StyledVerticalSectionsContainer_1 = require("components/Dashboard/StyledVerticalSectionsContainer");
const StyledSectionsContainer_1 = require("components/Dashboard/StyledSectionsContainer");
const StyledSubsectionContainer_1 = require("components/Dashboard/StyledSubsectionContainer");
const StyledBoldText_1 = require("components/Dashboard/StyledBoldText");
const StyledSectionText_1 = require("components/Dashboard/StyledSectionText");
const StyledLowerSection_1 = require("components/Dashboard/StyledLowerSection");
const StyledMessageContainer_1 = require("components/Dashboard/StyledMessageContainer");
const StyledMediumText_1 = require("components/Dashboard/StyledMediumText");
const StyledErrorText_1 = require("components/Dashboard/StyledErrorText");
const StyledGraphic_1 = require("components/Dashboard/StyledGraphic");
const StyledGreyText_1 = require("components/Dashboard/StyledGreyText");
const StyledTooltip_1 = require("components/Dashboard/Tooltip/StyledTooltip");
const StyledLegendTooltip_1 = require("components/Dashboard/Tooltip/StyledLegendTooltip");
const StyledTooltipContainer_1 = require("components/Dashboard/Tooltip/StyledTooltipContainer");
const AccountContext_1 = require("contexts/AccountContext");
const pageCount = 12;
const arrivalMapping = Object.freeze({
    Early: 'EARLY',
    Late: 'LATE',
    'On Time': 'ON_TIME'
});
const statuses = Object.keys(arrivalMapping);
const carrierMappings = {
    'APC Postal Logistics': 'APC_POSTAL_LOGISTICS',
    'Australia Post': 'AUSTRALIA_POST',
    'Canada Post': 'CANADA_POST',
    'DHL eCommerce': 'DHL_ECOMMERCE',
    'DHL Express': 'DHL_EXPRESS',
    'DPD UK': 'DPD_UK',
    FedEx: 'FEDEX',
    'FedEx Smart Post': 'FEDEX_SMART_POST',
    FirstMile: 'FIRSTMILE',
    GLS: 'GSO',
    'Japan Post': 'JAPAN_POST',
    LaserShip: 'LASERSHIP',
    Newgistics: 'NEWGISTICS',
    Passport: 'PASSPORT',
    Purolator: 'PUROLATOR',
    'RR Donnelley': 'RR_DONNELLEY',
    UPS: 'UPS',
    'UPS Mail Innovations': 'UPS_MAIL_INNOVATIONS',
    USPS: 'USPS',
    Yamato: 'YAMATO'
};
const carriers = Object.keys(carrierMappings);
const intervalMappings = {
    'Last 7 days': (0, moment_1.default)().subtract(7, 'days').format('YYYY-MM-DD'),
    'Last 14 days': (0, moment_1.default)().subtract(14, 'days').format('YYYY-MM-DD'),
    'Last 28 days': (0, moment_1.default)().subtract(28, 'days').format('YYYY-MM-DD'),
    'This month to date': (0, moment_1.default)().startOf('month').format('YYYY-MM-DD'),
    'This quarter to date': (0, moment_1.default)().startOf('quarter').format('YYYY-MM-DD')
};
const intervals = Object.keys(intervalMappings);
const secondsInADay = 60 * 60 * 24;
const Header = (props) => {
    const { onArrivalChanged, arrivalValue, onDateRangeChanged, dateRangeValue, onCarrierChanged, carrierValue } = props;
    return (react_1.default.createElement(StyledHeaderContainer_1.StyledHeaderContainer, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement(StyledSubHeader_1.StyledSubHeader, { className: 'header', role: 'heading' }, shippingCopy_1.shippingCopy.subHeader),
            react_1.default.createElement(StyledHeader_1.StyledHeader, { className: 'header', role: 'heading' }, shippingCopy_1.shippingCopy.mainHeader)),
        react_1.default.createElement(StyledInputsContainer_1.StyledInputsContainer, null,
            react_1.default.createElement(DatePickerInput_1.default, { callback: onDateRangeChanged, options: intervals, selection: dateRangeValue }),
            react_1.default.createElement(StyledFilterContainer_1.StyledFilterContainer, null,
                react_1.default.createElement(FilterDropdown_1.default, { callback: onArrivalChanged, margin: { left: 10 }, options: statuses, placeholder: 'Arrival', selection: arrivalValue }),
                react_1.default.createElement(FilterDropdown_1.default, { callback: onCarrierChanged, margin: { left: 10 }, options: carriers, placeholder: 'Carrier', selection: carrierValue, wide: true })))));
};
const Shipping = () => {
    const { account } = (0, AccountContext_1.useAccount)();
    const { id: accountId } = account || {};
    const [detailedShipment, setDetailedShipment] = react_1.default.useState({});
    const [showModal, setShowModal] = react_1.default.useState(false);
    const [arrival, setArrival] = (0, queryParams_1.default)('arrival', 'default');
    const [carrier, setCarrier] = (0, queryParams_1.default)('carrier', 'default');
    const [selectedRange, setSelectedRange] = (0, queryParams_1.default)('range', {
        range: 'Last 7 days',
        from: {},
        to: {}
    });
    const [getShipmentReport, { loading: reportLoading, error: reportError, data: reportData }] = (0, client_1.useLazyQuery)(queryDefinitions_1.GET_SHIPMENT_REPORT);
    const [getShipments, { loading: tableLoading, error: tableError, data: tableData, fetchMore: shipmentFetchMore }] = (0, client_1.useLazyQuery)(queryDefinitions_1.GET_SHIPMENTS);
    const [searchQuery, setSearchQuery] = react_1.default.useState('');
    const [reportValuesAndPercents, setReportValuesAndPercents] = (0, react_1.useState)({
        percents: [0, 0, 0],
        values: [0, 0, 0]
    });
    function handleLoadNext() {
        if (tableData && tableData.shipments.pageInfo.hasNextPage) {
            shipmentFetchMore({
                variables: {
                    after: tableData.shipments.pageInfo.endCursor,
                    first: pageCount
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    const newEdges = fetchMoreResult.shipments.edges;
                    const pageInfo = fetchMoreResult.shipments.pageInfo;
                    return newEdges.length
                        ? {
                            shipments: {
                                __typename: previousResult.shipments.__typename,
                                edges: [...previousResult.shipments.edges, ...newEdges],
                                pageInfo
                            }
                        }
                        : previousResult;
                }
            });
        }
    }
    (0, useInfiniteScroll_1.useInfiniteScroll)({
        hasNext: tableData === null || tableData === void 0 ? void 0 : tableData.shipments.pageInfo.hasNextPage,
        loadNext: handleLoadNext
    });
    (0, react_1.useEffect)(() => {
        if (!(reportData === null || reportData === void 0 ? void 0 : reportData.shipmentReport)) {
            return;
        }
        const onTimeValue = reportData.shipmentReport.totalOnTimeCount;
        const earlyValue = reportData.shipmentReport.totalEarlyCount;
        const lateValue = reportData.shipmentReport.totalLateCount;
        const onTimePercent = Math.round((onTimeValue / reportData.shipmentReport.totalCount) * 100);
        const earlyPercent = Math.round((earlyValue / reportData.shipmentReport.totalCount) * 100);
        const latePercent = Math.round((lateValue / reportData.shipmentReport.totalCount) * 100);
        setReportValuesAndPercents({
            percents: [onTimePercent, earlyPercent, latePercent],
            values: [onTimeValue, earlyValue, lateValue]
        });
    }, [reportData]);
    function handleToggleModal() {
        setShowModal((current) => !current);
    }
    function convertDate(date) {
        if (date < 10) {
            return `0${date}`;
        }
        return date;
    }
    function handleSetDate(range, custom) {
        if (custom) {
            setSelectedRange({
                range: 'Custom interval',
                from: range.from ? range.from : {},
                to: range.to ? range.to : {}
            });
        }
        else {
            setSelectedRange({
                range: range,
                from: { year: 'none' },
                to: { year: 'none' }
            });
        }
    }
    function handleSetCarrier(selection) {
        setCarrier(selection);
    }
    function handleSetArrival(selection) {
        setArrival(selection);
    }
    function handlePressButton(shipment) {
        setDetailedShipment(shipment.node);
        handleToggleModal();
    }
    function hasSearchQuery() {
        return searchQuery && searchQuery.trim() !== '';
    }
    (0, react_1.useEffect)(() => {
        if (shipmentFetchMore && tableData) {
            // guard against shipmentFetchMore not being set yet
            shipmentFetchMore({
                variables: hasSearchQuery() ? { q: searchQuery } : {},
                updateQuery: (_previousResult, { fetchMoreResult }) => {
                    const newEdges = fetchMoreResult.shipments.edges;
                    const pageInfo = fetchMoreResult.shipments.pageInfo;
                    return {
                        shipments: {
                            __typename: 'shipments',
                            edges: [...newEdges],
                            pageInfo
                        }
                    };
                }
            });
        }
    }, [searchQuery, shipmentFetchMore]);
    // eslint-disable-next-line complexity
    (0, useAccountChange_1.default)(() => {
        let toVar = '';
        let fromVar = '';
        if (selectedRange.range === 'Custom interval' &&
            selectedRange.to.year &&
            selectedRange.from.year) {
            fromVar = `${selectedRange.from.year}-${convertDate(selectedRange.from.month)}-${convertDate(selectedRange.from.day)}`;
            toVar = `${selectedRange.to.year}-${convertDate(selectedRange.to.month)}-${convertDate(selectedRange.to.day)}`;
        }
        if (selectedRange.range !== 'Custom interval') {
            toVar = (0, moment_1.default)().format('YYYY-MM-DD');
            // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            fromVar = intervalMappings[selectedRange.range];
        }
        if (toVar && fromVar) {
            if (arrival === 'default' && carrier === 'default') {
                getShipmentReport({
                    variables: {
                        accountId,
                        endDate: toVar,
                        startDate: fromVar
                    }
                });
                getShipments({
                    variables: {
                        accountId,
                        endDate: toVar,
                        startDate: fromVar,
                        first: pageCount
                    }
                });
            }
            else if (arrival === 'default') {
                getShipmentReport({
                    variables: {
                        accountId,
                        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                        carrier: carrierMappings[carrier],
                        endDate: toVar,
                        startDate: fromVar
                    }
                });
                getShipments({
                    variables: {
                        accountId,
                        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                        carrier: carrierMappings[carrier],
                        endDate: toVar,
                        startDate: fromVar,
                        first: pageCount
                    }
                });
            }
            else if (carrier === 'default') {
                getShipmentReport({
                    variables: {
                        accountId,
                        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                        arrival: arrivalMapping[arrival],
                        endDate: toVar,
                        startDate: fromVar
                    }
                });
                getShipments({
                    variables: {
                        accountId,
                        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                        arrival: arrivalMapping[arrival],
                        endDate: toVar,
                        startDate: fromVar,
                        first: pageCount
                    }
                });
            }
            else {
                getShipmentReport({
                    variables: {
                        accountId,
                        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                        arrival: arrivalMapping[arrival],
                        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                        carrier: carrierMappings[carrier],
                        endDate: toVar,
                        startDate: fromVar
                    }
                });
                getShipments({
                    variables: {
                        accountId,
                        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                        arrival: arrivalMapping[arrival],
                        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                        carrier: carrierMappings[carrier],
                        endDate: toVar,
                        startDate: fromVar,
                        first: pageCount
                    }
                });
            }
        }
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'any' is not assignable to type 'never'.
    }, [accountId, arrival, carrier, selectedRange]);
    function handleSearch(query) {
        setSearchQuery(query);
    }
    function displayError(apiError) {
        if (apiError.message.includes('ECONNREFUSED') ||
            apiError.message.toLowerCase().includes('failed')) {
            return (react_1.default.createElement(StyledErrorText_1.StyledErrorText, { className: 'error', role: 'alert' }, shippingCopy_1.shippingCopy.fetchError));
        }
        return apiError.graphQLErrors.map(({ message }, i) => (react_1.default.createElement(StyledErrorText_1.StyledErrorText, { className: 'error', key: i, role: 'alert' }, message)));
    }
    function renderLoading() {
        return (react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, null,
            react_1.default.createElement(LoadingSpinner_1.default, null),
            react_1.default.createElement(StyledMediumText_1.StyledMediumText, { className: 'loading', role: 'paragraph' }, shippingCopy_1.shippingCopy.loading)));
    }
    function renderNoShipments() {
        return (react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, { height: '515px' },
            react_1.default.createElement(StyledGraphic_1.StyledGraphic, { alt: 'document emerging from a filing cabinet', src: noSearch_webp_1.default }),
            react_1.default.createElement(StyledHeader_1.StyledHeader, { "aria-level": 1, className: 'no-shipments-header', role: 'heading' }, shippingCopy_1.shippingCopy.noShipmentsHeader),
            react_1.default.createElement(StyledGreyText_1.StyledGreyText, { className: 'no-shipments', role: 'paragraph' }, shippingCopy_1.shippingCopy.noShipmentsParagraph)));
    }
    function renderShipments() {
        var _a;
        const { percents, values } = reportValuesAndPercents;
        return (react_1.default.createElement("div", { className: 'fade show' },
            react_1.default.createElement(StyledSectionsContainer_1.StyledSectionsContainer, null,
                react_1.default.createElement(StyledSectionContainer_1.StyledSectionContainer, null,
                    react_1.default.createElement(StyledSubsectionContainer_1.StyledSubsectionContainer, { header: true, height: '60px' },
                        react_1.default.createElement(StyledSectionText_1.StyledSectionText, { role: 'heading' }, shippingCopy_1.shippingCopy.section1)),
                    react_1.default.createElement(StyledSubsectionContainer_1.StyledSubsectionContainer, { height: '380px', vertical: true },
                        react_1.default.createElement(PieChart_1.default, { labels: ['On Time', 'Early', 'Late'], percents: percents, values: values }),
                        react_1.default.createElement(StyledTooltipContainer_1.StyledTooltipContainer, null,
                            react_1.default.createElement(StyledLegendTooltip_1.StyledLegendTooltip, { right: '127%', src: tooltip_svg_1.default }),
                            react_1.default.createElement(StyledLegendTooltip_1.StyledLegendTooltip, { left: '133%', src: tooltip_svg_1.default }),
                            react_1.default.createElement(StyledLegendTooltip_1.StyledLegendTooltip, { left: '385%', src: tooltip_svg_1.default })))),
                react_1.default.createElement(StyledVerticalSectionsContainer_1.StyledVerticalSectionsContainer, null,
                    react_1.default.createElement(StyledSectionContainer_1.StyledSectionContainer, { margin: '30px', width: '100%' },
                        react_1.default.createElement(StyledSubsectionContainer_1.StyledSubsectionContainer, { height: '90px' },
                            react_1.default.createElement("div", null,
                                react_1.default.createElement(StyledSubHeader_1.StyledSubHeader, { role: 'heading' }, shippingCopy_1.shippingCopy.section2),
                                react_1.default.createElement(StyledBoldText_1.StyledBoldText, { className: 'shipments-tracked' }, reportData.shipmentReport.totalCount.toLocaleString())),
                            react_1.default.createElement(StyledIcon_1.StyledIcon, { className: 'fe fe-package', margin: '15px' }))),
                    react_1.default.createElement(StyledSectionContainer_1.StyledSectionContainer, { width: '100%' },
                        react_1.default.createElement(StyledSubsectionContainer_1.StyledSubsectionContainer, { header: true, height: '80px' },
                            react_1.default.createElement(StyledSectionText_1.StyledSectionText, null, shippingCopy_1.shippingCopy.section3),
                            react_1.default.createElement(StyledIcon_1.StyledIcon, { className: 'fe fe-sun', margin: '15px' })),
                        react_1.default.createElement(StyledSubsectionContainer_1.StyledSubsectionContainer, { height: '80px' },
                            react_1.default.createElement("div", null,
                                react_1.default.createElement(StyledSubHeader_1.StyledSubHeader, { role: 'heading' },
                                    shippingCopy_1.shippingCopy.section4,
                                    react_1.default.createElement(StyledTooltip_1.StyledTooltip, { src: tooltip_svg_1.default })),
                                react_1.default.createElement(StyledBoldText_1.StyledBoldText, { className: 'placed-delivery' }, reportData.shipmentReport.avgPlacedToDelivery
                                    ? (reportData.shipmentReport.avgPlacedToDelivery /
                                        secondsInADay).toFixed(2)
                                    : '—'))),
                        react_1.default.createElement(StyledSubsectionContainer_1.StyledSubsectionContainer, { height: '80px' },
                            react_1.default.createElement("div", null,
                                react_1.default.createElement(StyledSubHeader_1.StyledSubHeader, { role: 'heading' },
                                    shippingCopy_1.shippingCopy.section5,
                                    react_1.default.createElement(StyledTooltip_1.StyledTooltip, { src: tooltip_svg_1.default })),
                                react_1.default.createElement(StyledBoldText_1.StyledBoldText, { className: 'placed-fulfill' }, reportData.shipmentReport.avgPlacedToFulfill
                                    ? (reportData.shipmentReport.avgPlacedToFulfill /
                                        secondsInADay).toFixed(2)
                                    : '—'))),
                        react_1.default.createElement(StyledSubsectionContainer_1.StyledSubsectionContainer, { height: '80px' },
                            react_1.default.createElement("div", null,
                                react_1.default.createElement(StyledSubHeader_1.StyledSubHeader, { role: 'heading' },
                                    shippingCopy_1.shippingCopy.section6,
                                    react_1.default.createElement(StyledTooltip_1.StyledTooltip, { src: tooltip_svg_1.default })),
                                react_1.default.createElement(StyledBoldText_1.StyledBoldText, { className: 'fulfill-delivery' }, reportData.shipmentReport.avgFulfillToDelivery
                                    ? (reportData.shipmentReport.avgFulfillToDelivery /
                                        secondsInADay).toFixed(2)
                                    : '—')))))),
            react_1.default.createElement(StyledLowerSection_1.StyledLowerSection, null,
                react_1.default.createElement(DataTable_1.default, { button: shippingCopy_1.shippingCopy.tableButton, data: ((_a = tableData === null || tableData === void 0 ? void 0 : tableData.shipments) === null || _a === void 0 ? void 0 : _a.edges) || [], dataType: 'shipment', headers: [
                        shippingCopy_1.shippingCopy.column1,
                        shippingCopy_1.shippingCopy.column2,
                        shippingCopy_1.shippingCopy.column3,
                        shippingCopy_1.shippingCopy.column4,
                        shippingCopy_1.shippingCopy.column5
                    ], loading: tableLoading, onPressButton: handlePressButton, onSearch: handleSearch }))));
    }
    let content = null;
    if (reportError) {
        content = react_1.default.createElement("div", null, displayError(reportError));
    }
    else if (tableError) {
        content = react_1.default.createElement("div", null, displayError(tableError));
    }
    else if (reportLoading || tableLoading) {
        content = renderLoading();
    }
    else if (!reportData || reportData.shipmentReport.totalCount === 0) {
        content = renderNoShipments();
    }
    else {
        content = renderShipments();
    }
    return (react_1.default.createElement(StyledMainContainer_1.StyledMainContainer, { className: 'shipping' },
        react_1.default.createElement(ShippingModal_1.default, { display: showModal, handleToggleModal: handleToggleModal, shipment: detailedShipment }),
        react_1.default.createElement(Header, { arrivalValue: arrival, carrierValue: carrier, dateRangeValue: selectedRange, onArrivalChanged: handleSetArrival, onCarrierChanged: handleSetCarrier, onDateRangeChanged: handleSetDate }),
        react_1.default.createElement("div", { style: { minHeight: '100vh' } }, content)));
};
exports.default = Shipping;
